<template>
  <div>
    <div class="container">
      <e-search
        :data="filterInfo.data"
        :field-list="filterInfo.fieldList"
        :width="filterInfo.width"
        :list-type-info="listTypeInfo"
        @handleFilter="handleFilter"
        @handleReset="handleReset"
      ></e-search>
    </div>
    <div class="container">
      <tableList
        :loading="loading"
        :index-show="true"
        :table-data="tableData"
        row-key="chargeNoticeId"
        :table-label="tableLabel"
        style="margin-top: 20px"
      >
        <template v-slot:chargeNoticeNo="{scope:{row}}">
          <div class="theme">{{row.chargeNoticeNo}}</div>
        </template>
        <template v-slot:payeeCompanyName="{scope:{row}}">
          <e-tooltip
            mode="width" :content="row.payeeCompanyName"
          />
        </template>
        <template v-slot:payerCompanyName="{scope:{row}}">
          <e-tooltip
            mode="width" :content="row.payerCompanyName"
          />
        </template>
        <template v-slot:divideProfitStatus="{ scope: { row } }">
          <span :class="{'no-mark': row.divideProfitStatus === 0}">
            {{getDictName(listTypeInfo.divideProfitStatusList, row.divideProfitStatus)}}
          </span>
        </template>
        <template v-slot:divideProfitAmount="{ scope: { row } }">
          <span>
            {{row.divideProfitAmount | thousandsSeparator}}
          </span>
        </template>
        <template v-slot:divideProfitType="{ scope: { row } }">
          <span :class="row.divideProfitType === 1 ? 'client' : 'resource'">
            {{getDictName(listTypeInfo.divideProfitTypeList,row.divideProfitType)}}
          </span>
        </template>
      </tableList>

      <div class="pagination">
        <div>
          总计：<span>{{statisticalData.totalAmount | thousandsSeparator}}元</span>
          已分配：<span>{{statisticalData.allocatedAmount | thousandsSeparator}}元</span>
          未分配：<span>{{statisticalData.notAllocatedAmount | thousandsSeparator}}元</span>
        </div>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="queryData.pageNum"
          :page-size="queryData.pageSize"
          :total="queryData.pageTotal"
          prev-text="上一页"
          next-text="下一页"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import eSearch from '@/modules/projectA/components/common/e-search';
import tableList from '@/modules/projectA/components/common/e-table-list';
import api from '@/modules/projectA/api/order';
import eTooltip from '@/modules/projectA/components/common/e-tooltip';
import { businessTypeList, divideProfitTypeList, divideProfitStatusList, getDictName } from './commonData';

export default {
  name: 'index',
  components: { eSearch, tableList, eTooltip },
  data() {
    return {
      loading: false,
      visible: false,
      tableData: [],
      tableLabel: [
        {
          label: '收费通知书编号',
          slot: 'chargeNoticeNo',
          align: 'center',
          width: 140
        },
        {
          label: '收款公司',
          slot: 'payeeCompanyName',
          align: 'center'
        },
        {
          label: '付款单位',
          slot: 'payerCompanyName',
          align: 'center'
        },
        {
          label: '收费金额（元）',
          align: 'right',
          headerAlign: 'right',
          slot: 'divideProfitAmount',
        },
        {
          label: '分润类型',
          align: 'center',
          slot: 'divideProfitType',
        },
        {
          label: '分润来源',
          param: 'businessType',
          align: 'center',
          render: ({ businessType }) => {
            return getDictName(businessTypeList, businessType);
          },
        },
        {
          label: '标记状态',
          slot: 'divideProfitStatus',
          align: 'center',
        },
        {
          label: '创建时间',
          param: 'createTime',
          align: 'center',
          width: 160
        }
      ],
      queryData: {
        businessType: null,
        payerCompanyName: '',
        divideProfitType: null,
        divideProfitStatus: null,
        createTime: null,
        pageNum: 1,
        pageSize: 10,
        pageTotal: 0
      },
      filterInfo: {
        data: {
          businessType: null,
          payerCompanyName: '',
          divideProfitType: null,
          divideProfitStatus: null,
          createTime: null
        },
        fieldList: [
          {
            label: '分润来源',
            type: 'select',
            value: 'businessType',
            list: 'businessTypeList'
          },
          { label: '付款公司 ', type: 'input', value: 'payerCompanyName' },
          {
            label: '分润类型',
            type: 'select',
            value: 'divideProfitType',
            list: 'divideProfitTypeList'
          },
          {
            label: '标记状态',
            type: 'select',
            value: 'divideProfitStatus',
            list: 'divideProfitStatusList'
          },
          {
            label: '创建时间',
            type: 'date',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            dateType: 'daterange',
            value: 'createTime'
          }
        ]
      },
      listTypeInfo: {
        divideProfitStatusList,
        businessTypeList,
        divideProfitTypeList
      },
      statisticalData: {
        allocatedAmount: '',
        notAllocatedAmount: '',
        totalAmount: ''
      }
    };
  },
  methods: {
    getDictName,
    handleSizeChange(val) {
      this.queryData.pageSize = val;
      this.queryData.pageNum = 1;
      this.queryPage();
      this.divideProfitGetCount();
    },
    handleCurrentChange(val) {
      this.queryData.pageNum = val;
      this.queryPage();
      this.divideProfitGetCount();
    },
    handleFilter(val) {
      this.queryData = { ...this.queryData, ...val, pageNum: 1, pageTotal: undefined };
      this.queryPage();
      this.divideProfitGetCount();
    },
    handleReset() {
      this.queryData = {
        businessType: null,
        payerCompanyName: '',
        divideProfitType: null,
        divideProfitStatus: null,
        createTime: null,
        pageNum: 1,
        pageSize: 10,
        pageTotal: 0
      };
      this.queryPage();
      this.divideProfitGetCount();
    },
    queryPage() {
      this.loading = true;
      api.divideProfitPayeeQueryPage({
        ...this.queryData,
        createTime: null,
        createTimeStrStart: this.queryData.createTime && this.queryData.createTime[0],
        createTimeStrEnd: this.queryData.createTime && this.queryData.createTime[1]
      }).then((res) => {
        if (res.code === '200') {
          this.tableData = res.data.records;
          this.queryData.pageTotal = res.data.total;
        }
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    async divideProfitGetCount() {
      const res = await api.divideProfitPayeeGetCount({
        ...this.queryData,
        createTime: null,
        createTimeStrStart: this.queryData.createTime && this.queryData.createTime[0],
        createTimeStrEnd: this.queryData.createTime && this.queryData.createTime[1]
      });
      if (res.code === '200') {
        this.statisticalData = res.data;
      }
    }
  },
  mounted() {
    this.queryPage();
    this.divideProfitGetCount();
  }
};
</script>

<style scoped lang="scss">
  @import '@/assets/css/theme.scss';

  .pagination {
    margin-top: 0;

    > div:nth-child(1) {
      text-align: right;
      height: 40px;
      line-height: 40px;
      background: #f5f5f5;
      border: 1px solid #ebeef5;
      border-top: 0;
      margin-bottom: 20px;
      font-size: 12px;
      font-weight: bold;
      color: #333333;

      > span {
        color: #E50113;
        margin-right: 10px;
      }
    }
  }

  .no-mark {
    color: #E50113;
  }

  .client {
    color: #50AA43;
  }

  .resource,
  .theme {
    color: $main-col;
  }

  ::v-deep .el-button--small {
    padding: 0 0 0 10px;
    margin-left: 0;
  }

  ::v-deep {
    .has-gutter {
      tr > th:nth-child(5) {
        text-align: right !important;
      }
    }
  }
</style>
